<template>
  <div v-if="openTableName" class="open-table-banner">
    <div class="table-name">
      <strong>Open Table:</strong> {{ openTableName }}
    </div>
  </div>
</template>

<script>
export default {
  name: "OpenTableName",
  computed: {
    openTableName() {
      return this.$store.getters.getOpenTableName;
    },
  },
  methods: {
    goToTables() {
      this.$router.push({ name: 'tables' });
    },
  },
};
</script>

<style scoped>
.open-table-banner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

.table-name {
  font-size: 1.1em;
}
</style> 